/**
 * Labstep
 *
 * @module components/Folder/Pane/List
 * @desc List of folders
 */

import { FolderActionCreateSub } from 'labstep-web/components/Folder/Action/CreateSub';
import {
  Action,
  FolderActionMenu,
} from 'labstep-web/components/Folder/Action/Menu';
import { ICONS } from 'labstep-web/constants/icons';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import Tree from 'labstep-web/core/Tree';
import { Folder } from 'labstep-web/models/folder.model';
import type React from 'react';
import type { FolderPaneListProps } from './types';

export const FolderPaneList: React.FC<FolderPaneListProps> = ({
  activeGroup,
  folderType,
  action,
  searchBarProps,
}) => (
  <Tree
    folderType={folderType}
    entityName={Folder.entityName}
    childKeyName="outer_folder"
    icon={ICONS.folder.primary}
    iconInactive={ICONS.folder.info.unselected}
    getCornerIcon={(entity) => {
      const folder = entity as Folder;
      return folder.is_sharing_enabled
        ? {
            cornerIcon: 'share alternate',
            cornerIconPosition: 'bottom right' as const,
          }
        : {};
    }}
    createSubAction={(entity) => (
      <FolderActionCreateSub
        folder={entity as Folder}
        folderType={folderType}
        actionComponentProps={{ type: 'text', icon: 'plus' }}
      />
    )}
    actionMenu={(entity, options) => (
      <FolderActionMenu
        folder={entity as Folder}
        folderType={folderType}
        actions={[
          Action.edit,
          Action.share,
          Action.delete,
          Action.add_subfolders,
          Action.update_outer,
          Action.assign,
        ]}
        options={options}
      />
    )}
    unsorted={
      activeGroup?.getIsUnsortedFolderEnabled(folderType)
        ? {
            icon: ICONS.folder.info.unsorted,
            text: 'Unsorted',
            param: 'is_unsorted',
          }
        : undefined
    }
    params={{ type: folderType }}
    action={action}
    searchBarProps={searchBarProps}
  />
);

export default withActiveGroup(FolderPaneList);
